
import { Order, DashboardStats, ThirdPartyLogistics, ServicePrice, SavedProduct, Address } from '@/types';

export const mockOrders: Order[] = [
  {
    id: 'DH001',
    sender: 'Nguyễn Văn A',
    senderPhone: '0901234567',
    recipient: 'Trần Văn B',
    recipientPhone: '0909876543',
    address: 'Số 123, Đường Láng, Hà Nội',
    detailedAddress: 'Số 123, Đường Láng',
    addressType: 'old',
    province: 'Hà Nội',
    district: 'Đống Đa',
    ward: 'Láng Thượng',
    codAmount: 500000,
    paymentBy: 'recipient',
    weight: 2.5,
    dimensions: '30x20x15',
    service: 'Hỏa tốc',
    products: [
      { id: 'p1', name: 'Quần áo', value: 300000, weight: 1.5, quantity: 2 },
      { id: 'p2', name: 'Giày dép', value: 200000, weight: 1.0, quantity: 1 }
    ],
    status: 'Đang giao',
    timestamp: '2025-01-13T08:30:00+07:00',
    estimatedCost: 45000,
    trackingHistory: [
      {
        status: 'Đã tạo đơn',
        time: '2025-01-13T08:30:00+07:00',
        location: 'Hà Nội',
        description: 'Đơn hàng được tạo thành công'
      },
      {
        status: 'Đang vận chuyển',
        time: '2025-01-13T10:00:00+07:00',
        location: 'Hà Nội',
        description: 'Hàng đã được lấy và bắt đầu vận chuyển'
      },
      {
        status: 'Đến bưu cục',
        time: '2025-01-13T14:30:00+07:00',
        location: 'Đà Nẵng',
        description: 'Hàng đã đến bưu cục trung chuyển'
      }
    ],
    editHistory: [
      {
        time: '2025-01-13T08:35:00+07:00',
        user: 'Nguyễn Văn A',
        changes: 'Cập nhật địa chỉ giao hàng',
        reason: 'Địa chỉ cũ không chính xác'
      }
    ]
  },
  {
    id: 'DH002',
    sender: 'Trần Thị B',
    senderPhone: '0987654321',
    recipient: 'Lê Văn C',
    recipientPhone: '0369852147',
    address: 'Số 456, Đường Nguyễn Huệ, Đà Nẵng',
    detailedAddress: 'Số 456, Đường Nguyễn Huệ',
    addressType: 'new',
    province: 'Đà Nẵng',
    ward: 'Thạch Thang',
    codAmount: 750000,
    paymentBy: 'sender',
    weight: 1.2,
    dimensions: '25x15x10',
    service: 'Tiết kiệm',
    products: [
      { id: 'p3', name: 'Sách giáo khoa', value: 150000, weight: 0.8, quantity: 5 },
      { id: 'p4', name: 'Văn phòng phẩm', value: 100000, weight: 0.4, quantity: 1 }
    ],
    status: 'Đã giao',
    timestamp: '2025-01-12T15:20:00+07:00',
    estimatedCost: 25000,
    is3PL: true,
    thirdPartyId: '3PL001',
    trackingHistory: [
      {
        status: 'Đã tạo đơn',
        time: '2025-01-12T15:20:00+07:00',
        location: 'Đà Nẵng',
        description: 'Đơn hàng được tạo thành công'
      },
      {
        status: 'Chuyển 3PL',
        time: '2025-01-12T16:00:00+07:00',
        location: 'Hệ thống',
        description: 'Đơn hàng được chuyển cho đối tác 3PL'
      },
      {
        status: 'Giao thành công',
        time: '2025-01-13T09:15:00+07:00',
        location: 'Hải Phòng',
        description: 'Giao hàng thành công đến người nhận'
      }
    ]
  }
];

export const mockDashboardStats: DashboardStats = {
  totalOrders: 1247,
  revenue: 45680000,
  customers: 892,
  trips: 156,
  successRate: 94.2,
  revenueByDay: [
    { name: '07/01', orders: 45, revenue: 2100000 },
    { name: '08/01', orders: 52, revenue: 2450000 },
    { name: '09/01', orders: 38, revenue: 1890000 },
    { name: '10/01', orders: 61, revenue: 2980000 },
    { name: '11/01', orders: 49, revenue: 2340000 },
    { name: '12/01', orders: 55, revenue: 2680000 },
    { name: '13/01', orders: 43, revenue: 2210000 },
  ],
  ordersByStatus: [
    { name: 'Hoàn thành', value: 65, color: 'hsl(142, 76%, 36%)' },
    { name: 'Đang giao', value: 20, color: 'hsl(221, 83%, 53%)' },
    { name: 'Chờ xử lý', value: 10, color: 'hsl(48, 96%, 53%)' },
    { name: 'Khác', value: 5, color: 'hsl(210, 40%, 80%)' },
  ],
};

export const mockThirdPartyProviders: ThirdPartyLogistics[] = [
  {
    id: '3PL001',
    name: 'Giao Hàng Nhanh',
    apiUrl: 'https://api.ghn.vn',
    apiKey: 'ghn_api_key_123',
    status: 'active',
    ordersCount: 245,
    successRate: 96.5
  },
  {
    id: '3PL002',
    name: 'Viettel Post',
    apiUrl: 'https://api.viettelpost.vn',
    apiKey: 'vtp_api_key_456',
    status: 'active',
    ordersCount: 156,
    successRate: 94.2
  },
  {
    id: '3PL003',
    name: 'J&T Express',
    apiUrl: 'https://api.jtexpress.vn',
    apiKey: 'jt_api_key_789',
    status: 'inactive',
    ordersCount: 89,
    successRate: 92.8
  }
];

export const mockServicePrices: ServicePrice[] = [
  {
    id: 'srv1',
    service: 'Hỏa tốc',
    basePrice: 35000,
    weightPrice: 8000,
    distanceMultiplier: 1.5,
    estimatedTime: '4-6 giờ'
  },
  {
    id: 'srv2',
    service: 'Nhanh',
    basePrice: 25000,
    weightPrice: 5000,
    distanceMultiplier: 1.2,
    estimatedTime: '24 giờ'
  },
  {
    id: 'srv3',
    service: 'Tiết kiệm',
    basePrice: 18000,
    weightPrice: 3000,
    distanceMultiplier: 1.0,
    estimatedTime: '48-72 giờ'
  }
];

export const mockSavedProducts: SavedProduct[] = [
  {
    id: 'sp1',
    name: 'Quần áo',
    defaultValue: 300000,
    defaultWeight: 0.5,
    category: 'Thời trang',
    isFrequent: true
  },
  {
    id: 'sp2',
    name: 'Giày dép',
    defaultValue: 500000,
    defaultWeight: 0.8,
    category: 'Thời trang',
    isFrequent: true
  },
  {
    id: 'sp3',
    name: 'Sách giáo khoa',
    defaultValue: 50000,
    defaultWeight: 0.3,
    category: 'Sách vở',
    isFrequent: false
  },
  {
    id: 'sp4',
    name: 'Điện thoại',
    defaultValue: 10000000,
    defaultWeight: 0.2,
    category: 'Điện tử',
    isFrequent: false
  }
];

export const mockAddresses: Address[] = [
  {
    id: 'addr1',
    name: 'Nguyễn Văn A',
    phone: '0901234567',
    province: 'Hà Nội',
    district: 'Đống Đa',
    ward: 'Láng Thượng',
    detailedAddress: 'Số 123, Đường Láng',
    isDefault: true,
    type: 'sender'
  },
  {
    id: 'addr2',
    name: 'Trần Thị B',
    phone: '0987654321',
    province: 'Hồ Chí Minh',
    ward: 'Bến Nghé',
    detailedAddress: 'Số 456, Đường Nguyễn Huệ',
    isDefault: false,
    type: 'recipient'
  }
];
